import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'navy.800');
  const sectionBgColor = useColorModeValue('gray.50', 'navy.900');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const inputBackground = useColorModeValue('gray.50', 'navy.900');
  const inputBgColor = useColorModeValue('white', 'navy.800');
  const headingBgColor = useColorModeValue('gray.100', 'whiteAlpha.100');

  const validStatusBg = useColorModeValue('green.100', 'green.500');
  const invalidStatusBg = useColorModeValue('red.100', 'red.500');
  const validStatusColor = useColorModeValue('green.600', 'green.900');
  const invalidStatusColor = useColorModeValue('red.600', 'red.900');

  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');

  const filterSectionBg = useColorModeValue('white', 'navy.800');
  const filterBg = useColorModeValue('white', 'navy.800');
  const filterOptionHover = useColorModeValue('gray.100', 'navy.700');
  const filterOptionChecked = useColorModeValue('blue.50', 'navy.900');
  const filterHover = useColorModeValue('gray.50', 'whiteAlpha.100');
  const filterChecked = useColorModeValue('white', 'whiteAlpha.50');

  const getStatusColors = (isValid) => ({
    bg: isValid ? validStatusBg : invalidStatusBg,
    color: isValid ? validStatusColor : invalidStatusColor,
  });

  return {
    backgroundCardColor,
    sectionBgColor,
    borderColor,
    textColor,
    inputBackground,
    inputBgColor,
    headingBgColor,
    getStatusColors,
    inputColor,
    filterSectionBg,
    filterBg,
    filterOptionHover,
    filterOptionChecked,
    filterHover,
    filterChecked,
  };
};
